import PayPalPage from './paypal_page'
import { connect } from 'react-redux'
import { fromMobileSelector } from 'redux/selectors/mobile'
import { getAllowEntryBannerSelector } from 'redux/selectors/campaign'

const mapStateToProps = (state, { campaignId, showHeader, showFooter }) => {
  const fromMobile = fromMobileSelector()(state)
  if (fromMobile) {
    showHeader = false
    showFooter = false
  }

  return {
    showHeader,
    showFooter,
    isLoggedIn: state.login_info && state.login_info.logged_in,
    allowEntryBanner: getAllowEntryBannerSelector(state, { campaignId }),
    paypalDomain: state.geo.paypalDomain,
    banner: state.personalizationStudio.banner,
  }
}
export default connect(mapStateToProps)(PayPalPage)
